<template>
  <v-dialog v-model="dialog" persistent max-width="420">
    <v-card>
      <v-card-title>
        <div class="title-modal-layout">
          <div @click="close" class="close">
            <v-icon>mdi-close</v-icon>
          </div>
        </div>
      </v-card-title>
      <v-card-text>
        <SevenClubMember
          :isAuthenticated="true"
          @verified="handleVerified"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import SevenClubMember from '@/components/bnn/SevenClubMember'

export default {
  components: {
    SevenClubMember,
  },

  data() {
    return {
      dialog: false,
    }
  },
  unmounted() {
    this.dialog = false
  },
  methods: {
    open() {
      this.dialog = true
    },

    close() {
      this.dialog = false

      // if there is an error in the member state, reset it
      if (this.$store.state.user.member?.isError) {
        this.$store.dispatch('user/resetMember')
      }
    },

    handleVerified() {
      this.$route.push({
        query: {
          ...this.$route.query,
          member_request_key: undefined,
        },
      })

      // if history state has 'member_request_key' remove it from the history state
      if (window.history.state && window.history.state.back) {
        // Remove 'member_request_key' from the history state
        const newState = { ...window.history.state }
        delete newState.back.query.member_request_key
        window.history.replaceState(newState, '')
      }

      this.close()
    },
  },
}
</script>

<style lang="stylus" scoped>

.title-modal-layout
    display: flex
    justify-content: flex-end
    width: 100%
    .close
        cursor: pointer
</style>
